import { defineAsyncComponent } from '../../lib/utils/vue3compat/vue.js?vue3';
import produce from 'immer';
import { GlButton, GlDrawer, GlLabel, GlModal, GlModalDirective } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { MountingPortal } from '../../lib/utils/vue3compat/portal_vue_vue3.js?vue3';
import { ListType, ListTypeTitles, listsQuery, deleteListQueries } from 'ee_else_ce/boards/constants';
import { isScopedLabel } from '~/lib/utils/common_utils';
import { __, s__ } from '~/locale';
import Tracking from '../../tracking/index.js?vue3';
import glLicensedFeaturesMixin from '~/vue_shared/mixins/gl_licensed_features_mixin';
import { setError } from '../graphql/cache_updates.js?vue3';
export default {
    name: 'BoardSettingsSidebar',
    listSettingsText: __('List settings'),
    i18n: {
        modalAction: __('Remove list'),
        modalCopy: __('Are you sure you want to remove this list?'),
        modalCancel: __('Cancel')
    },
    components: {
        GlButton,
        GlModal,
        GlDrawer,
        GlLabel,
        MountingPortal,
        BoardSettingsSidebarWipLimit: defineAsyncComponent(()=>import('../../../../../ee/app/assets/javascripts/boards/components/board_settings_wip_limit.vue?vue3')),
        BoardSettingsListTypes: defineAsyncComponent(()=>import('../../../../../ee/app/assets/javascripts/boards/components/board_settings_list_types.vue?vue3'))
    },
    directives: {
        GlModal: GlModalDirective
    },
    mixins: [
        glLicensedFeaturesMixin(),
        Tracking.mixin()
    ],
    inject: [
        'boardType',
        'canAdminList',
        'issuableType',
        'scopedLabelsAvailable',
        'isIssueBoard'
    ],
    inheritAttrs: false,
    props: {
        listId: {
            type: String,
            required: true
        },
        list: {
            type: Object,
            required: false,
            default: ()=>{}
        },
        queryVariables: {
            type: Object,
            required: true
        }
    },
    emits: [
        'unset-active-id'
    ],
    data () {
        return {
            ListType
        };
    },
    modalId: 'board-settings-sidebar-modal',
    computed: {
        isWipLimitsOn () {
            return this.glLicensedFeatures.wipLimits && this.isIssueBoard;
        },
        activeListId () {
            return this.listId;
        },
        activeList () {
            return this.list;
        },
        activeListLabel () {
            return this.activeList.label;
        },
        boardListType () {
            return this.activeList.type || this.activeList.listType || null;
        },
        listTypeTitle () {
            return ListTypeTitles[ListType.label];
        },
        showSidebar () {
            return Boolean(this.listId);
        }
    },
    methods: {
        handleModalPrimary () {
            this.deleteBoardList();
        },
        showScopedLabels (label) {
            return this.scopedLabelsAvailable && isScopedLabel(label);
        },
        deleteBoardList () {
            this.track('click_button', {
                label: 'remove_list'
            });
            this.deleteList(this.activeListId);
            this.unsetActiveListId();
        },
        unsetActiveListId () {
            this.$emit('unset-active-id');
        },
        async deleteList (listId) {
            try {
                await this.$apollo.mutate({
                    mutation: deleteListQueries[this.issuableType].mutation,
                    variables: {
                        listId
                    },
                    update: (store)=>{
                        store.updateQuery({
                            query: listsQuery[this.issuableType].query,
                            variables: this.queryVariables
                        }, (sourceData)=>produce(sourceData, (draftData)=>{
                                draftData[this.boardType].board.lists.nodes = draftData[this.boardType].board.lists.nodes.filter((list)=>list.id !== listId);
                            }));
                    }
                });
            } catch (error) {
                setError({
                    error,
                    message: s__('Boards|An error occurred while deleting the list. Please try again.')
                });
            }
        }
    }
};
